import { render } from "./PrivilegesEditModal.vue?vue&type=template&id=ae56b12a"
import script from "./PrivilegesEditModal.vue?vue&type=script&lang=js"
export * from "./PrivilegesEditModal.vue?vue&type=script&lang=js"

import "./PrivilegesEditModal.vue?vue&type=style&index=0&id=ae56b12a&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__